import _ from 'lodash';
import CredentialsApi from '../../api/CredentialsApi';
import sourcesFields from '../../constants/sourcesFields';

const state = {
  eligibleForDiscountPromotion: false,
};

const actions = {
  async initDiscountPromotion({ commit }) {
    const credentials = await CredentialsApi.fetchCredentials();
    const hasDiscountCreds = _.some(credentials, _isDiscountCreds);
    commit('setEligibleForDiscountPromotion', hasDiscountCreds);
  },
};

const mutations = {
  setEligibleForDiscountPromotion(state, isEligible) {
    state.eligibleForDiscountPromotion = isEligible; // eslint-disable-line
  },
};

function _isDiscountCreds(creds) {
  const { allSourceFields } = sourcesFields;
  const discountSourceNames = [allSourceFields.discount.sourceName, allSourceFields['discount-api'].sourceName];
  return _.includes(discountSourceNames, creds.sourceName);
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
